import { LocalStorageHelpers as Storage } from './localStorageHelpers.js';
const LAST_ACTIVITY = 'last_activity';
const TIMEOUT_INFO = 'timeout_info';
export const PING_INTERVAL = 60000; // 1 min
class TimeoutInfo {
    constructor({ globalLastActivity = 0, localLastActivity = 0, globalTimeOut = 0, }) {
        this.getNextPingInterval = () => {
            const timeoutIn = this.globalTimeOut - new Date().getTime();
            if (timeoutIn < PING_INTERVAL) {
                return timeoutIn > 0 ? timeoutIn : 0;
            }
            return PING_INTERVAL;
        };
        this.globalLastActivity = globalLastActivity;
        this.localLastActivity = localLastActivity;
        this.globalTimeOut = globalTimeOut;
    }
    isGlobalBehindLocal() {
        // to avoid too much unnecessary requests, so the different is in PING_INTERVAL consider as no different.
        return this.localLastActivity - this.globalLastActivity > PING_INTERVAL;
    }
}
export const getActivityTime = () => Storage.getNumber(LAST_ACTIVITY);
export const storeActivityTime = (activityTime) => {
    Storage.setNumber(LAST_ACTIVITY, activityTime !== null && activityTime !== void 0 ? activityTime : new Date().getTime());
};
export const getTimeoutInfo = () => {
    const timeoutInfo = Storage.getJson(TIMEOUT_INFO);
    if (!timeoutInfo)
        return null;
    return new TimeoutInfo({
        ...timeoutInfo,
        localLastActivity: getActivityTime(),
    });
};
export const storeTimeoutInfo = (timeoutInfo) => {
    Storage.setJson(TIMEOUT_INFO, timeoutInfo);
};
export const storeUserActivityInfo = (remoteTimeoutInfo) => {
    if (!remoteTimeoutInfo)
        return;
    const localTimeoutInfo = getTimeoutInfo();
    if (!localTimeoutInfo) {
        storeTimeoutInfo(remoteTimeoutInfo);
    }
    else {
        if (localTimeoutInfo.localLastActivity < remoteTimeoutInfo.globalLastActivity) {
            storeActivityTime(remoteTimeoutInfo.globalLastActivity);
        }
        if (localTimeoutInfo.globalLastActivity < remoteTimeoutInfo.globalLastActivity) {
            storeTimeoutInfo(remoteTimeoutInfo);
        }
    }
};
